// extracted by mini-css-extract-plugin
export default {"link":"wF-z","disabled":"xF-z"};